import { REPLIES_ENDPOINT } from "../constants/settings";
import { myFetch } from "../helpers/myFetch";

export const getReplies = () => {
  return myFetch(`${REPLIES_ENDPOINT}`, "GET");
};
